import { Dialog } from '@mui/material';
import type { PropsWithChildren } from 'react';

import { SlideUpTransition } from '../animations/transitions';

interface BottomDialogProps {
  open: boolean;
  isFullScreen?: boolean;
}

export const BottomDialog = (props: PropsWithChildren<BottomDialogProps>) => {
  const { open, children, isFullScreen } = props;
  return (
    <Dialog
      slots={{ transition: SlideUpTransition }}
      open={open}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: '100%',
          height: '85%',
          margin: 0,
          alignSelf: 'end',
          marginLeft: isFullScreen ? '0' : '60px',
        },
      }}
    >
      {children}
    </Dialog>
  );
};
